// extracted by mini-css-extract-plugin
module.exports = {"link":"SuppressedDefaultActionLink_link__Q93dS"};